var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CCol',{attrs:{"col":"12","sm":"6","lg":"3"}},[_vm._v(" Welcome to Oceanbolt internal admin. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }